<template>
  <div class="edit-feature-form">
    <div class="ef-col">
      <create-service :item-saved="itemsSaved"/>
    </div>
    <div class="ef-col">
      <div class="ef-row" v-if="!refreshServices">
        <h2>Edit Current Features</h2>
        <service-item :is-edit="is_edit_service(service._id)" :canceled="service_cancelled" :updated="service_updated" :item="service" v-for="service in services" :key="service._id" />
      </div>
    </div>
  </div>
</template>

<script>
import CreateService from './CreateService'
import ServiceItem from './ServiceItem'
export default {
  name: 'ManageServices',
  components: {
    CreateService,
    ServiceItem
  },
  data () {
    return {
      name: '',
      refreshServices: false,
      services: [],
      selectedService: null
    }
  },
  watch: {
    refreshServices () {
      if (this.refreshServices) {
        setTimeout(() => {
          this.refreshServices = false
        }, 500)
      }
    }
  },
  mounted () {
    this.getServiceList()
  },
  computed: {},
  methods: {
    is_edit_service (id) {
      let result = false
      if (this.selectedService) {
        if (this.selectedService._id === id) {
          result = true
        }
      }
      return result
    },
    itemsSaved (result) {
      console.log(result)
      this.getServiceList()
    },
    service_updated (updated, data) {
      if (!updated) {
        this.refreshServices = true
        this.selectedService = null
        this.getServiceList()
      } else {
        this.refreshServices = true
        this.selectedService = data
        this.getServiceList()
      }
    },
    service_cancelled () {
      this.selectedService = null
    },
    getServiceList () {
      this.$vs.loading()
      const payload = {
        page: 0
      }
      this.$store.dispatch('getServiceList', payload)
        .then(response => {
          console.log('response', response)
          this.services = response.data
          this.$vs.loading.close()
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>

<style scoped>

</style>
